<app-navtop></app-navtop>

<div class="container-fluid pt-5">
    <div class="d-flex flex-row bd-highlight"> 
        <div class="col-xl-10 col-lg-10 col-md-10  p-2 mx-xl-auto mx-lg-auto mx-md-auto content-main">
           
            <!-- Profile & Cover Picture -->
            <div class="card mx-auto border-0 shadow-lg">
                <img *ngIf="!(peopleDoc | async)?.coverPictureUrl" [src]="coverPicture" class="card-img-top img-cover">
                <img *ngIf="(peopleDoc | async)?.coverPictureUrl" [src]="(peopleDoc | async)?.coverPictureUrl"  class="card-img-top img-cover">
                
                <!-- Cover Picture -->
                <input type="file" hidden (change)="addCoverPictureDoc($event, spinnerModalContent)" #selectCoverPicture accept=".jpeg,.jpg" class="form-control"/>
                <button type="button" class="img-cover-btn btn btn-light btn-sm position-absolute rounded shadow"
                    (click)="selectCoverPicture.click()">
                    <svg class="bi bi-camera-fill" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M10.5 8.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"/>
                        <path d="M2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 3.172 4H2zm.5 2a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm9 2.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0z"/>
                    </svg>
                    Change Cover Picture
                </button>
                <!-- Profile Picture -->
                <div class="d-flex align-items-center justify-content-center mb-5">
                    <!-- <img [src]="peoplePhoto" alt="..." class="img-profile position-absolute rounded-circle shadow-lg"> -->
                    <img *ngIf="!(peopleDoc | async)?.profilePictureUrl" [src]="profilePicture"  class="img-profile position-absolute rounded-circle shadow-lg">                    
                    <img *ngIf="(peopleDoc | async)?.profilePictureUrl" [src]="(peopleDoc | async)?.profilePictureUrl"  class="img-profile position-absolute rounded-circle shadow-lg">
                    
                    <input type="file" hidden (change)="addProfilePictureDoc($event, spinnerModalContent)" #selectProfilePicture accept=".jpeg,.jpg" class="form-control"/>                   
                    <svg class="bi bi-camera-fill position-absolute btn btn-light rounded-circle" 
                        (click)="selectProfilePicture.click()" 
                        style="margin-left:100px; margin-top:50px" 
                        xmlns="http://www.w3.org/2000/svg" width="52" height="52" fill="currentColor" 
                        viewBox="0 0 16 16">
                        <path d="M10.5 8.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"/>
                        <path d="M2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 3.172 4H2zm.5 2a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm9 2.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0z"/>
                    </svg>
                </div>
                <div class="card-body">
                    <div class="h2 text-center">{{ (peopleDoc | async)?.nameFirst }} {{ (peopleDoc | async)?.nameLast }}</div>
                </div>               
            </div>

            <!-- Spinner Modal -->
            <ng-template #spinnerModalContent>
                <div class="modal" style="display: flex; justify-content: center; align-items: center;">
                    <div class="spinner-grow text-danger"></div>
                </div>
            </ng-template>
            
            <div class="row"> 
                <!-- Left Column -->               
                <div class="col-xl-6 col-lg-6 col-md-12">   
                    <!-- Testing display on Sreen SIzes -->
                    <!-- <button class="btn btn-primary d-none d-sm-block">Large</button>
                    <button class="btn btn-primary d-sm-none">small</button> -->

                    <!-- About Card -->
                    <div class="card my-3 shadow-lg card-sticky">
                        <div class="card-body">
                            <h2>About</h2>
                            <ul class="list-group list-group-flush">   
                                <li class="list-group-item">                                  
                                First Name(s): <br>
                                {{(peopleDoc | async)?.nameFirst}}
                                </li>
                                <li class="list-group-item">                                  
                               Last Name: <br>
                               {{(peopleDoc | async)?.nameLast}}
                                </li>                             
                                <li class="list-group-item">                                  
                                Email: <br>
                                {{(peopleDoc | async)?.email}}
                                </li>
                                
                              </ul>    
                            <button type="button" class="btn btn-dark btn-sm btn-block mt-3" (click)="openUpdatePeopleModalForm(updatePeopleContent)">Edit About</button>
                            <hr class="m-3">
                            <button type="button" class="btn btn-danger btn-sm btn-block" (click)="openConfirmSignOutModal(confirmSignOutContent)">Log Out</button>
                        </div>
                    </div> 

                    <!-- Confirm SignOut - Modal -->
                    <ng-template #confirmSignOutContent let-c="close" let-d="dismiss">               
                        <div class="modal-body">
                            <div class="card">
                                <div class="card-body">
                                <h2 class="card-title">Confirm Log Out</h2>
                                <p class="card-text">Confirm you want to Log Out</p>
                                <button (click)="peopleSignOut()" class="btn btn-danger m-2">Log Out</button>
                                <button (click)="closeConfirmSignOutModal()" class="btn btn-secondary text-white m-2">Cancel</button>
                                </div>
                            </div>
                        </div>
                    </ng-template>

                    <!-- Detail Update Form-->  
                    <ng-template #updatePeopleContent let-c="close" let-d="dismiss">
                        <div class="modal-body">
                            <div class="p-2 mb-3">
                                <h2>Update Profile Details</h2>
                                <p>Update details and click Update button.</p>                   
                                <br/>
                                <form [formGroup]="updatePeopleForm" (ngSubmit)="updatePeopleDoc(updatePeopleForm.value)">  
                                    <small>First Name(s)</small>
                                    <div class="form-group">
                                        <input type="text" class="form-control"  
                                        required
                                        maxlength="20"
                                        minlength="2"  
                                        [ngModel]="(peopleDoc | async)?.nameFirst" 
                                        [formControlName]="'nameFirst'"  
                                        placeholder="First Name"/>                        
                                    </div> 
                                    <small>Last Name</small>
                                    <div class="form-group">
                                        <input type="text" class="form-control" 
                                        required
                                        maxlength="20"
                                        minlength="2"                               
                                        [ngModel]="(peopleDoc | async)?.nameLast" 
                                        [formControlName]="'nameLast'"  
                                        placeholder="Last Name"/>                        
                                    </div>                              
                                    <!-- <small>Mobile Number</small>                        
                                    <div class="form-group">
                                        <input type="text" class="form-control" readonly
                                        [ngModel]="(peopleDoc | async)?.phoneNumber" 
                                        [formControlName]="'phoneNumber'" 
                                        placeholder="Phone Number"/>                        
                                    </div>                             -->
                                    <div class="form-group">
                                        <button type="submit" class="btn btn-danger m-1" [disabled]="!updatePeopleForm.valid">Update</button>
                                        <button class="btn btn-warning m-1" (click)="closeUpdatePeopleModalForm()">Cancel</button>   
                                    </div>   
                                </form> 
                            </div>
                        </div>
                    </ng-template>          
                </div>
                
                <!-- Right Column -->  
                <div class="col-xl-6 col-lg-6 col-md-12">   
                    <!-- Page Managed -->
                    <div class="card my-3 shadow-lg">
                        <div class="card-body">
                            <h2>Pages Managed</h2>
                            <div class="list-group list-group-flush">
                                <a class="list-group-item list-group-item-action" routerLink=""  
                                    *ngFor="let doc of businessColOwned | async; let i = index"
                                    (click)="routeToGovernmentDetailPage(doc.id)">
                                    <div class="media">   
                                        <img *ngIf="!doc.profilePictureUrl" [src]="businessProfilePicture"  class="mr-3 align-self-center rounded-circle image">                    
                                        <img *ngIf="doc.profilePictureUrl" [src]="doc.profilePictureUrl"  class="mr-3 align-self-center rounded-circle image">                     
                                        <div class="media-body">
                                            <div class="font-weight-bolder h5">{{doc.name}}</div>
                                            <p>
                                                <span *ngIf="doc.publish" class="badge badge-success p-2 m-1">Published</span>
                                                <span *ngIf="!doc.publish" class="badge badge-danger p-2 m-1">Unpublish</span>                                                
                                                <span class="badge badge-dark p-2 m-1">{{doc.serviceId}}</span>
                                                <span class="badge badge-dark p-2 m-1">{{doc.colId}}</span>
                                                <span class="badge badge-dark p-2 m-1">Government Profile</span>                                                
                                            </p>
                                        </div>
                                    </div>                                                       
                                </a>
                            </div>          
                        
                            <div *ngIf="businessDocLength === 0" class="my-3">
                                <div class="alert alert-danger" role="alert"
                                [innerHTML]="">
                                    <p>Page Administrator will see the Profiles, Travels, or Stores pages they manage here.</p>
                                    <br>
                                    <!-- <p>Users can now add their or other business profile pages they have been authorized to manage the business's digital marketing platforms.</p>
                                    <br>
                                    <p>Are you a business owner or an authorized individual? Click the "Create New Business" button to list your first business on PNGL.</p>
                                    <button type="button" class="btn btn-dark btn-sm btn-block mt-3"
                                    (click)="openAddBusinessModalForm(addBusinessContent)">
                                    Create New Business
                                    </button> -->
                                </div>                                                           
                            </div>
                        </div>            
                    </div> 

                    <!-- Modal - Add Business Form -->
                    <ng-template #addBusinessContent let-c="close" let-d="dismiss">
                        <div class="modal-body" >
                            <div class="p-2 mb-3">
                                <h2>Add New Business</h2>
                                <p>Add Business details and click add button.</p>
                                <br/>
                                <form [formGroup]="addBusinessForm" (ngSubmit)="addBusinessDoc(addBusinessForm.value)">  
                                    <div class="form-group">
                                    <input type="text" class="form-control"
                                    required
                                    maxlength="30"
                                    minlength="4"
                                    formControlName="name" 
                                    placeholder="Business Name (required)"/>                        
                                    </div>
                                    <select class="custom-select form-control mb-2" required formControlName="category" >
                                        <option selected>Select Category</option>
                                        <option *ngFor="let doc of businessCategoryCol | async">{{doc.name}}</option>
                                    </select>                    
                                    <div class="form-group">
                                        <button type="submit" class="btn btn-danger m-1" [disabled]="!addBusinessForm.valid">Add</button>
                                        <button class="btn btn-warning m-1" (click)="closeAddBusinessModalForm()">Cancel</button>
                                    </div>     
                                </form>  
                            </div> 
                        </div>
                    </ng-template>   

                   <!-- Page Following -->
                    <div class="card my-3 shadow-lg">
                        <div class="card-body">
                            <h2>Page Following</h2>
                            <!-- <ul class="list-group list-group-flush">
                                <li class="list-group-item font-weight-bold">
                                  <div class="media">                        
                                      <img [src]="coverPicture" class="mr-3 align-self-center rounded image" alt="...">
                                      <div class="media-body align-self-center">
                                        PNGL
                                      </div>
                                  </div> 
                                </li>                                
                            </ul>  -->
                            <div class="alert alert-danger my-3" role="alert">
                                Followed PNGL Business, Government, Tour Package, Handicraft Store, or Painting Store Profile Pages will be listed here.
                            </div>
                            <!-- <button type="button" class="btn btn-warning btn-sm btn-block mt-3">Load More</button> -->
                        </div>
                    </div>

                    <!-- Post Liked -->
                    <div class="card my-3 shadow-lg">
                        <div class="card-body">
                            <h2>Post Liked</h2>
                            <!-- <ul class="list-group list-group-flush">
                                <li class="list-group-item font-weight-bold">
                                  <div class="media">                        
                                      <img [src]="coverPicture" class="mr-3 align-self-center rounded image" alt="...">
                                      <div class="media-body align-self-center">
                                        PNGL
                                      </div>
                                  </div> 
                                </li>                                
                            </ul>  -->
                            <div class="alert alert-danger my-3" role="alert">
                                Liked posts from Business or Government Profile Pages will be listed here.
                            </div>
                            <!-- <button type="button" class="btn btn-warning btn-sm btn-block mt-3">Load More</button> -->
                        </div>
                    </div> 

                    <!-- Profile Pictures -->
                    <div class="card my-3 shadow-lg">
                        <div class="card-body">
                            <h2>Profile Pictures</h2>
                            <div class="alert alert-danger my-3" *ngIf="profilePictureColDocLenght === 0" role="alert">
                                Your personnel profile still contains the default profile picture.
                                To upload a profile picture of yourself, click the "Upload Profile Picture" button. 
                                <button type="button" class="btn btn-dark btn-sm btn-block mt-3"
                                    (click)="selectProfilePicture.click()">
                                    Upload Profile Picture
                                </button>
                            </div>
                            <div class="row row-cols-2">
                                <div class="col" *ngFor="let doc of profilePictureCol | async; let i = index">
                                    <div class="card m-1">                                        
                                        <img [src]="doc.pictureUrl" class="img-post">
                                        <svg class="bi bi-trash3-fill position-absolute btn btn-light rounded-circle"                                             
                                            *ngIf="(peopleDoc | async)?.profilePictureUrl != doc.pictureUrl"
                                            (click)="deleteProfilePictureDoc(doc.id, doc.pictureUrl)"
                                            style="right:10px; bottom:10px" 
                                            xmlns="http://www.w3.org/2000/svg" width="52" height="52" fill="currentColor" 
                                            viewBox="0 0 16 16">
                                            <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z"/>
                                        </svg>  
                                        <svg class="bi bi-pencil-fill position-absolute btn btn-light rounded-circle"                                             
                                            *ngIf="(peopleDoc | async)?.profilePictureUrl != doc.pictureUrl"
                                            (click)="updateProfilePictureDoc(doc.pictureUrl)"
                                            style="left:10px; bottom:10px" 
                                            xmlns="http://www.w3.org/2000/svg" width="52" height="52" fill="currentColor" 
                                            viewBox="0 0 16 16">
                                            <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z"/>
                                        </svg>                                         
                                    </div>                                    
                                </div>                                                              
                            </div>
                            <!-- <button type="button" class="btn btn-warning btn-sm btn-block mt-3">Load More</button> -->
                        </div>
                    </div> 

                    <!-- Cover Pictures -->
                    <div class="card my-3 shadow-lg">
                        <div class="card-body">
                            <h2>Cover Pictures</h2>
                            <div class="alert alert-danger my-3" *ngIf="coverPictureColDocLenght === 0" role="alert">
                                Your personnel profile still contains the default cover picture.
                                To upload your first cover picture, click the "Upload Cover Picture" button. 
                                <button type="button" class="btn btn-dark btn-sm btn-block mt-3"
                                    (click)="selectCoverPicture.click()">
                                    Upload Cover Picture
                                </button>
                            </div>
                            <div class="row row-cols-2 my-2">
                                <div class="col" *ngFor="let doc of coverPictureCol | async; let i = index">
                                    <div class="card m-1" >
                                        <img [src]="doc.pictureUrl" class="img-post">
                                        <svg class="bi bi-trash3-fill position-absolute btn btn-light rounded-circle"                                             
                                        *ngIf="(peopleDoc | async)?.coverPictureUrl != doc.pictureUrl"
                                        (click)="deleteCoverPictureDoc(doc.id, doc.pictureUrl)"
                                        style="right:10px; bottom:10px" 
                                            xmlns="http://www.w3.org/2000/svg" width="52" height="52" fill="currentColor" 
                                            viewBox="0 0 16 16">
                                            <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z"/>
                                        </svg>    
                                        <svg class="bi bi-pencil-fill position-absolute btn btn-light rounded-circle"                                             
                                            *ngIf="(peopleDoc | async)?.coverPictureUrl != doc.pictureUrl"
                                            (click)="updateCoverPictureDoc(doc.pictureUrl)"
                                            style="left:10px; bottom:10px" 
                                            xmlns="http://www.w3.org/2000/svg" width="52" height="52" fill="currentColor" 
                                            viewBox="0 0 16 16">
                                            <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z"/>
                                        </svg>                                       
                                    </div>                                    
                                </div>                                                              
                            </div>
                            <!-- <button type="button" class="btn btn-warning btn-sm btn-block mt-3">Load More</button> -->
                        </div>
                    </div> 
                </div>
            </div>    
            
            
            
        </div>
    </div>
</div>
